import React,{useState,useEffect} from 'react'
//redux stuff
import { useSelector, useDispatch} from 'react-redux';
import {setRallyNumber,incrementRallyNumber,setQuestionAnswered,setFlameOn} from "./redux/rallyTracker"

function AnswerScreenVerbs(props) {
     
     //random responses
     const goodResponseArray = ['Good Job','Way to go',"You're a genius",'Good for you','Keep Going!','WOW'];
     const badResponseArray = ['you idiot','nice job, stupid',"give up, loser",'you suck','kill yourself','nice try shitbag'];
     var random = Math.floor(Math.random() * goodResponseArray.length);
     const [goodResponse,setGoodResponse] = useState();
     const [badResponse,setBadResponse] = useState();

     //start these off true bc the HTML wont even render unless the answerSreenVerb var is true
     //answerSreenVerb exists to prevent this screen rendering at the start of the app or when the various sections (noun, verb) are expanded
     const [answerScreenOpen,setAnswerScreenOpen] = useState(true);
     const reduxFlameOn = useSelector((state) => state.rallyTracker.reduxFlameOn);

     var verbScreenSuccessOpen;
     
     //redux
     let dispatch = useDispatch();

     //if(props.section == 'verb'){
          //create an array to store wrong answers. compare the users entries to the answers and populate the array with a loop.
          //then we know below which of the users answers to mark a wrong :)
          var wrongVerbAnswers = {infinitive:'',I:'',you:'',he:'',we:'',yall:'',they:''};  
          //set this as 'dontKnowyet' so neither screen fires at the start
          var verbSuccess = 'dontKnowyet';

          for (const key in wrongVerbAnswers) {
               if(props.verbsAnswerObject[key].trim().toLowerCase() != props.verbsObject[key].trim().toLowerCase()){
                    wrongVerbAnswers[key] = "WRONG";
               }
               else{
                    wrongVerbAnswers[key] = "CORRECT"; 
               }
          }

          ///check to see if all answers are correct. if any are wrong, set verbSuccess to false
          for (const key in wrongVerbAnswers) {
               if(wrongVerbAnswers[key] == "CORRECT"){
                    verbSuccess = true;  

               }
               else{
                    verbSuccess =  false;
                    break;   
               }
          }  


          //if all verbs are correct, set the correct screen classes
          if(verbSuccess == true ){
               verbScreenSuccessOpen = true;
          }
          else{
               verbScreenSuccessOpen = false; 
          }         


          useEffect(() => {
               //we cant put this in the above "if(props.readyToOpen)" bc an infinite loop
               //previously we had the flameOn effect fire after you close the success screen. Which isnt as good as firing upon correct answer
               if(verbSuccess == true && props.answerSreenVerb == true ){
                    dispatch(incrementRallyNumber());
                    dispatch( setFlameOn(true) );
                    setTimeout(function(){
                         //after a second, turn the flame off. should be a short, quick thing
                         dispatch( setFlameOn(false) );
                    },2000);
               }
               setGoodResponse(goodResponseArray[random]);
               setBadResponse(badResponseArray[random]);
          }, [props.answerSreenVerb])







     function fadeOutScreen(answer){

          //set this true, that a question has been answered. Once this redux value is true, ONE useEffect
          //shared by all files will update the DB everytime the "reduxRallyNumber" is changed
          //but we dont want to do it on load
          dispatch( setQuestionAnswered(true) );

          //increase or reset the redux rally value if a success or wrong
          if(answer == 'correct'){

          }
          else if(answer == 'wrong'){
               dispatch(setRallyNumber(0))   
          }
          
          verbScreenSuccessOpen = false;
          console.log(answerScreenOpen);
          setAnswerScreenOpen(false);
          setTimeout(function(){
               //use setTimeout() bc theres no other place to reset this to true, so the screen can display again
               //we could do it in the parent compponent but shit is getting crazy
               setAnswerScreenOpen(true);
          },400);
          
     }////fadeOutScreen()

     return (
          <div>
               {/* ////////////////////////////////SUCCESS///////////////////////////////////////// */}
               { ( verbSuccess == true && props.answerSreenVerb == true ) &&
                    <div className={ answerScreenOpen ? 'successScreen' : "successScreenOFF"}>
                         <div className='center'>
                              <div className='goodJob'>{goodResponse}</div>
                              <div className='row'>
                                   <div className='half'><p className='main'>{props.verbsAnswerObject.verb}</p></div>
                                   <div className='half'><p className='infinitiveAnswer'>{props.verbsAnswerObject.infinitive}</p></div>
                              </div>
                              <div className='row'>
                                   <div className='half'>
                                        <p>I</p>
                                        <p className='answer'>{props.verbsAnswerObject.I}</p>
                                   </div>
                                   <div className='half'>
                                        <p>We</p>
                                        <p className='answer'>{props.verbsAnswerObject.we}</p>
                                   </div> 
                              </div>
                              <div className='row'>
                                   <div className='half'>
                                        <p>You</p>
                                        <p className='answer'>{props.verbsAnswerObject.you}</p>
                                   </div>
                                   <div className='half'>
                                        <p>Y'all</p>
                                        <p className='answer'>{props.verbsAnswerObject.yall}</p>
                                   </div> 
                              </div>
                              <div className='row'>
                                   <div className='half'>
                                        <p>He/She</p>
                                        <p className='answer'>{props.verbsAnswerObject.he}</p>
                                   </div>
                                   <div className='half'>
                                        <p>They</p>
                                        <p className='answer'>{props.verbsAnswerObject.they}</p>
                                   </div> 
                              </div>   
                            
                              <button onClick={ () => {props.continueAfterError(props.section);  fadeOutScreen('correct')} } className=''>Continue</button>                                    
                         </div>  

                         
                    </div>

               }


               {/* ////////////////////////////////SUCCESS///////////////////////////////////////// */}
               { ( verbSuccess == false && props.answerSreenVerb == true ) &&
                    
                    <div className={ answerScreenOpen ? 'wrongScreen' : "wrongScreenOFF"}>
                         <div>
                              <p className='black'> {badResponse}</p>
                              <p className='infinitiveTitle'> 
                                   <span className='answers'>Answers: </span>
                                   <span className={wrongVerbAnswers.infinitive == "WRONG" ? "wrongAnswer" : 'ignore'}>{props.verbsObject.infinitive}</span>
                                   <span>{props.verbsAnswerObject.infinitive}</span>
                              
                              </p>
                              <div className='row'>
                                   <div className='left'>
                                        <p>I</p>
                                        <span className={wrongVerbAnswers.I == "WRONG" ? "wrongAnswer" : 'ignore'}>{props.verbsObject.I}</span>
                                        <span>{props.verbsAnswerObject.I}</span>
                                   </div>
                                   <div className='left'>
                                        <p>We</p>
                                        <span className={wrongVerbAnswers.we == "WRONG" ? "wrongAnswer" : 'ignore'}>{props.verbsObject.we}</span>
                                        <span>{props.verbsAnswerObject.we}</span>
                                    </div>
                              </div>
                              <div className='row'>
                                   <div className='left'>
                                        <p>You</p>
                                        <span className={wrongVerbAnswers.you == "WRONG" ? "wrongAnswer" : 'ignore'}>{props.verbsObject.you}</span>
                                        <span>{props.verbsAnswerObject.you}</span>
                                   </div>
                                   <div className='left'>
                                        <p>Yall</p>
                                        <span className={wrongVerbAnswers.yall == "WRONG" ? "wrongAnswer" : 'ignore'}>{props.verbsObject.yall}</span>
                                        <span>{props.verbsAnswerObject.yall}</span>
                                    </div>
                              </div>
                              <div className='row'>
                                   <div className='left'>
                                        <p>He/She</p>
                                        <span className={wrongVerbAnswers.he == "WRONG" ? "wrongAnswer" : 'ignore'}>{props.verbsObject.he}</span>
                                        <span>{props.verbsAnswerObject.he}</span>
                                   </div>
                                   <div className='left'>
                                        <p>They</p>
                                        <span className={wrongVerbAnswers.they == "WRONG" ? "wrongAnswer" : 'ignore'}>{props.verbsObject.they}</span>
                                        <span>{props.verbsAnswerObject.they}</span>
                                    </div>
                              </div>


                              <button onClick={ () => {props.continueAfterError(props.section); props.stretch(props.section); fadeOutScreen('wrong')} }>Continue</button>
                         </div>
                    </div>
               }



          </div>
     )


}

export default AnswerScreenVerbs
